import {
  FETCH_POINT_LOADING,
  FETCH_POINT_DONE,
  FETCH_POINT_ERROR,

  FETCH_POINT_HISTORY_LOADING,
  FETCH_POINT_HISTORY_DONE,
  FETCH_POINT_HISTORY_ERROR,

  FETCH_POINT_VOUCHER_LOADING,
  FETCH_POINT_VOUCHER_DONE,
  FETCH_POINT_VOUCHER_ERROR,

  POST_POINT_REDEEM_LOADING,
  POST_POINT_REDEEM_DONE,
  POST_POINT_REDEEM_ERROR,

  FETCH_POINT_LEADERBOARD_LOADING,
  FETCH_POINT_LEADERBOARD_DONE,
  FETCH_POINT_LEADERBOARD_ERROR

} from './actions'

export default {
  [FETCH_POINT_LOADING] (state) {
    state.isLoadingpoint = true
  },
  [FETCH_POINT_DONE] (state, items) {
    state.pointitem = items
    state.isLoadingpoint = false
  },
  [FETCH_POINT_ERROR] (state, error) {
    state.errorpoint = error
    state.isLoadingpoint = false
  },

  [FETCH_POINT_HISTORY_LOADING] (state) {
    state.isLoadingpointHistory = true
  },
  [FETCH_POINT_HISTORY_DONE] (state, items) {
    state.pointHistoryitem = items
    state.isLoadingpointHistory = false
  },
  [FETCH_POINT_HISTORY_ERROR] (state, error) {
    state.errorpointHistory = error
    state.isLoadingpointHistory = false
  },

  [FETCH_POINT_VOUCHER_LOADING] (state) {
    state.isLoadingpointVoucher = true
  },
  [FETCH_POINT_VOUCHER_DONE] (state, items) {
    state.pointVoucher = items
    state.isLoadingpointVoucher = false
  },
  [FETCH_POINT_VOUCHER_ERROR] (state, error) {
    state.errorpointVoucher = error
    state.isLoadingpointVoucher = false
  },

  [POST_POINT_REDEEM_LOADING] (state) {
    state.isLoadingredeemPoint = true
  },
  [POST_POINT_REDEEM_DONE] (state, items) {
    state.redeemPoint = items
    state.isLoadingredeemPoint = false
  },
  [POST_POINT_REDEEM_ERROR] (state, error) {
    state.errorredeemPoint = error
    state.isLoadingredeemPoint = false
  },

  [FETCH_POINT_LEADERBOARD_LOADING] (state) {
    state.isLoadingLeaderboard = true
  },
  [FETCH_POINT_LEADERBOARD_DONE] (state, items) {
    state.itemLeaderboard = items
    state.isLoadingLeaderboard = false
  },
  [FETCH_POINT_LEADERBOARD_ERROR] (state, error) {
    state.errorLeaderboard = error
    state.isLoadingLeaderboard = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/andalinpoint/mutations.js